import Vue from 'vue';
import Router from 'vue-router';

import generalRoutes from '@/router/general';
import adminRoutes from '@/router/admin';

Vue.use(Router);

const routes = [
	...generalRoutes,
	...adminRoutes,
];

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	// linkActiveClass: 'active',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes,
});

export default router;
